import { Button, Form, Input } from "antd";

import "../login/login.scss";
import { useRecoverPassword } from "./useRecoverPassword";
import { Link } from "react-router-dom";

function UsernameStage() {
  return (
    <Form.Item
      name={"username"}
      rules={[
        {
          required: true,
          message: "Correo electrónico es requerido",
        },
      ]}
    >
      <Input type={"text"} placeholder={"Correo electrónico"} />
    </Form.Item>
  );
}

function NewPasswordStage() {
  return (
    <>
      <Form.Item
        name={"code"}
        rules={[
          {
            required: true,
            message: "Código es requerido",
          },
        ]}
      >
        <Input type="text" placeholder={"Código"} />
      </Form.Item>
      <Form.Item
        name={"password"}
        rules={[
          {
            required: true,
            message: "Nueva contraseña es requerida",
          },
        ]}
      >
        <Input type="password" placeholder={"Escriba una nueva contraseña"} />
      </Form.Item>
    </>
  );
}

function RecoverPassword() {
  const {
    form,
    handleForgotPassword,
    handleResetPassword,
    stage,
    loading,
    instructions,
  } = useRecoverPassword();
  return (
    <div className={"login-page"}>
      <div className={"background-image-container"}></div>
      <div className={"card"}>
        <div className={"login-container"}>
          <div className={"card-image-container"}></div>
          <div className={"card-content-container"}>
            <h1>Olvidaste tu contraseña</h1>
            <p>{instructions}</p>
            <Form
              requiredMark={false}
              form={form}
              className={"form"}
              style={{ width: "100%" }}
            >
              {stage === "USERNAME" ? <UsernameStage /> : null}

              {stage === "PASSWORD" ? <NewPasswordStage /> : null}

              <Button
                type={"primary"}
                style={{ background: "black" }}
                onClick={
                  stage === "USERNAME"
                    ? handleForgotPassword
                    : handleResetPassword
                }
                loading={loading}
              >
                Aceptar
              </Button>
              <Link
                to={"/login"}
                style={{ marginBottom: "12px", marginTop: "12px" }}
              >
                Volver al inicio de sesión
              </Link>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecoverPassword;
